export type DiscountCollection = {
  code: string;
  name: string;
  percentage: number;
};

export type Season = {
  code: string;
  name: string;
  collections: DiscountCollection[];
  finalDate: Date;
  initialDate: Date;
};

export type DiscountInfo = {
  actualSeason: Season;
  lastSeason: Season;
  percentagePastSeasons: number;
  percentageTimelessSeasons: number;
};

export type SeasonForm = {
  season: string;
  collections: {
    collection: string;
    name: string;
    discount: string;
  }[];
};

export type DiscountsForm = {
  percentagePastSeasons: string;
  percentageTimelessSeasons: string;
  actualSeason: SeasonForm;
  lastSeason: SeasonForm;
};

export enum Seasons {
  ActualSeason = 'actualSeason',
  LastSeason = 'lastSeason',
}

export type CustomDiscount = {
  season: string;
  collection: string;
  discount: number;
};

export type DiscountsPayload = {
  percentagePastSeasons: number;
  percentageTimelessSeasons: number;
  customDiscounts: CustomDiscount[];
};

export type DiscountHistoryEntry = {
  discountType: DiscountType;
  newDiscount: string;
  oldDiscount: string;
  customDiscount?: {
    collection: string;
    season: string;
  };
};

export type DiscountHistory = {
  date: Date;
  changedBy: string;
  entries: DiscountHistoryEntry[];
};

export type DiscountsChangeHistory = {
  changeHistory: DiscountHistory[];
};

export enum DiscountType {
  PastSeasons = 'PAST_SEASONS',
  TimelessSeason = 'TIMELESS_SEASON',
  CustomDiscount = 'CUSTOM_DISCOUNT',
}
